import React from 'react';
import defaultClasses from './columnLine.module.css';
import { useStyle } from '../../classify';

const ColumnLine = props => {
    const classes = useStyle(defaultClasses, props.classes);
    const { display, children } = props;
    const dynamicStyles = {
        display
    };

    return (
        <div style={dynamicStyles} className={classes.root}>
            {children}
        </div>
    );
};

export default ColumnLine;
